// extracted by mini-css-extract-plugin
export var disabled = "_o-a";
export var hierarchyLinkGray = "_o-4";
export var hierarchyLinkUnderline = "_o-3";
export var hierarchyPrimary = "_o-0";
export var hierarchySecondary = "_o-1";
export var hierarchyTertiary = "_o-2";
export var pressed = "_o-6";
export var themeAction = "_o-5";
export var themeDestructive = "_o-8";
export var themeNormal = "_o-7";
export var themeSuccess = "_o-9";